import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from '@env/environment';
import { HttpMethod } from '@core/http/http-method.enum';
import { handleError, makeRequest } from '@core/http/resource.utils';
import { ErrorService } from '@core/http/error.service';
import { UserContext, UserContextResponse } from '@core/models/user-context.model';
import { toUserContext } from '@core/utils/user-context.utils';

@Injectable({ providedIn: 'root' })
export class UserContextService {
    private readonly httpClient = inject(HttpClient);
    private readonly errorService = inject(ErrorService);
    private readonly baseUrl = environment.AWS.apiUrl.replace(/\/$/, '');

    public loadContext(): Observable<UserContext> {
        return makeRequest<UserContextResponse>(
            this.httpClient,
            HttpMethod.GET,
            `${this.baseUrl}/context`,
            {},
            handleError<UserContextResponse>('load user context', this.errorService, 'context')
        ).pipe(map(toUserContext));
    }
}
